import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { targetId: Number, programId: Number, relationshipId: Number };
  static targets = ["relationshipBar"]

  connect() {
    console.log('user--pending-connection connected')
    // If this was triggered by Turbo Stream, remove badges immediately
    if (!this.hasRelationshipBarTarget) {
      this.removeBadges();
    }
  }

  submitRequestResponse() {
    let data_hash = {};
    let has_target_id = this.hasTargetIdValue;
    let this_controller = this;

    if (has_target_id) {
      data_hash.target_id = this.targetIdValue;
      data_hash.program_id = this.programIdValue;
    }

    $.ajax({
      type: 'post',
      url: '/my/connections/pending',
      data: data_hash,
      dataType: 'json',
      success: function (data) {
        if (data.pending_connections == false) {
          // If this was triggered by Turbo Stream, remove badges immediately
          if (!this_controller.hasRelationshipBarTarget) {
            this_controller.removeBadges();
          }
        }

        // change the status icon next to the profile picture
        document.querySelectorAll('.status-icon').forEach(element => {
          if (data.matched === true) {
            element.classList.remove('pending');
            element.querySelector('i').classList.remove('fa-timer');
            element.classList.add('success');
            element.querySelector('i').classList.add('fa-check');
          } else {
            element.style.display = 'none';
          }
        });

        // this is only on the connections page
        const relationship_bar = document.querySelector('.relationship-bar-container.top-aligned');
        if (relationship_bar) {
          relationship_bar.style.display = 'none';
        }
      }
    });
  }

  removeBadges() {
    let badges_to_remove = document.querySelectorAll(
      `[data-alert-id="connection-${this.relationshipIdValue}-${this.programIdValue}"]`
    );
    badges_to_remove.forEach(element => {
      element.style.display = 'none';
    });
  }
}